import { render, staticRenderFns } from "./CorpSearch.vue?vue&type=template&id=055cc6ec&lang=pug"
import script from "./CorpSearch.vue?vue&type=script&lang=js"
export * from "./CorpSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports